import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6548c8a8&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\opusb-web-myactio\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6548c8a8')) {
      api.createRecord('6548c8a8', component.options)
    } else {
      api.reload('6548c8a8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6548c8a8&", function () {
      api.rerender('6548c8a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/shared/components/ThemePicker/index.vue"
export default component.exports